module.exports = __webpack_public_path__ + "img/kanban.bb8a8bf1.png";